// @ts-nocheck - legacy JS, bỏ dòng này khi migrate sang TS
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

if (typeof window !== 'undefined' && !window.process) {
    window.process = { env: { NODE_ENV: process.env.NODE_ENV || 'development' } };
}

